import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import axios from "axios";
import EmmResponseModal from "./EmmResponseModal";
import { useSelector } from "react-redux";

const BulkRefresh = ({ selectedRows, api, selectedOption }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [responses, setResponses] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const headers = useSelector((state) => state?.header);
  const [open, setOpen] = useState(false);

  const handleOpenDialog = () => setOpen(true);
  const handleCloseDialog = () => setOpen(false);
  const emmsheaders = useSelector((state) => state?.emmsheader);
  const handleBulkRefresh = async () => {
    const screenuserIds = selectedRows;
    setIsLoading(true);
    setIsModalOpen(true);
    setCurrentIndex(0);

    try {
      const json = {
        screenuserIds,
        operation: "loadStartUrl",
      };

      const requestBody = {
        path: "emm",
        query: {},
        emmsId: selectedOption,
        body: json,
        requestType: "POST",
        headers: emmsheaders?.emmsheaders?.headers,
      };

      const response = await axios.post(
        `${api}/emms/piggyback`,
        requestBody,
        headers
      );

      const result = response?.data || {};

      const formatted = {};
      screenuserIds.forEach((id) => {
        formatted[id] = {
          ...result[id],
          raw: result,
        };
      });

      setResponses(formatted);
    } catch (err) {
      console.error("Bulk refresh failed", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirmRefresh = () => {
    setOpen(false);
    handleBulkRefresh();
  };
  const handleCloseModal = () => {
    if (currentIndex < selectedRows.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      setIsModalOpen(false);
      setCurrentIndex(0);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpenDialog}
        disabled={selectedRows?.length === 0}
        sx={{ textTransform: "none" }}
      >
        Bulk Refresh
      </Button>

      <EmmResponseModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        isLoading={isLoading}
        response={responses}
      />

      <Dialog open={open} onClose={handleCloseDialog}>
        <DialogTitle>Confirm Refresh</DialogTitle>
        <DialogContent>
          This will refresh all the screens configured. Are you sure you want to
          refresh?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleConfirmRefresh} color="error" autoFocus>
            Yes, Refresh
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BulkRefresh;
